function formatMoney(cents, format) {
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || document.body.dataset.currency;

  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'narrowSymbol'
  }).format(Number(cents) / 100);
}

function unFormatMoney(str) {
  if (str != "") {
    var value = String(str).replace(/<[^>]*>/g, '').replace(/[^0-9.,-]/g, '');
    var decimal = value.match(/[.,](\d{1,2})$/);
    value = decimal ? value.slice(0, decimal.index).replace(/[.,]/g, '') + '.' + decimal[1] : value.replace(/[.,]/g, '');
    value = Math.round(Number(value) * 100);
  
  } else {
    var value = "empty";  
  }
  
  return value    
}

function removeFadeOut(element, speed) {
  var seconds = speed/1000;
  element.style.transition = "opacity "+seconds+"s ease";

  element.style.opacity = 0;
  setTimeout(function() {
      element.parentNode.removeChild(element);
  }, speed);
}

function quantityAnimation(button, value) {
  document.querySelector(".action-buttons .quantity span.qty-mask").className = "qty-mask";  
  requestAnimationFrame((time) => {
    requestAnimationFrame((time) => {
      document.querySelector(".action-buttons .quantity span.qty-mask").innerText = value;
      if (button == "plus") {
        document.querySelector(".action-buttons .quantity span.qty-mask").className = "qty-mask up";
      } else {
        document.querySelector(".action-buttons .quantity span.qty-mask").className = "qty-mask down";              
      }
    });
  });
}

function updateInstallment(element, price, format) {
  if (document.querySelector(element)) {
    var interest = document.querySelector(element).getAttribute('data-interest')
    var quantity = document.querySelector(element).getAttribute('data-quantity')
  
    var updateInstallment = ((unFormatMoney(price) * interest / 100) + unFormatMoney(price)) / quantity
  
    document.querySelector(element+' strong').textContent = formatMoney(updateInstallment, format)    
  }
}

function updateDiscount(element, compare, price, format) {
  var discount = formatMoney(unFormatMoney(compare) - unFormatMoney(price), format)
  document.querySelector(element).innerHTML = `<i class="fa-solid fa-check"></i> Save <b>${discount}</b> off on these lovely products!`
}

function updateDiscountsItem(items, key) {
  if (items.length > 0) {
    var totalDiscount = 0;
    
    for (var i = 0; i < items.length; i++) {
      var productID = items[i].id;
      var discountedPrice = formatMoney(items[i].final_price, format);
      var totalPrice = formatMoney(items[i].final_line_price, format);
      var discounts = items[i].discounts;
      var totalDiscount = totalDiscount + items[i].total_discount;
      var itemSecurityText = document.querySelector(`[data-product="${productID}"] .security-text`);
      
      if (discounts.length > 0) {
        for (var d = 0; d < discounts.length; d++) {
          var amount = formatMoney(discounts[d].amount, format);
          var title = discounts[d].title;
          
          if (document.querySelector(`[data-product="${productID}"] .security-text p.discount-coupon`) && document.querySelector(`[data-product="${productID}"] .security-text p.discount-coupon span.discount-name`).textContent.includes(title)) {
            document.querySelector(`[data-product="${productID}"] .security-text p.discount-coupon span.discount-name`).textContent = title;
            document.querySelector(`[data-product="${productID}"] .security-text p.discount-coupon span.discount-amount`).textContent = amount;
          } else {
            itemSecurityText.innerHTML += `<p class="discount-coupon"><i class="fa-regular fa-circle-check"></i> <span class="discount-name">${title}</span> (-<span class="discount-amount">${amount}</span>)</p>`;
          }
          
          document.querySelector(`[data-product="${productID}"] .product-price .price`).textContent = totalPrice;
          document.querySelector(`[data-product="${productID}"] .product-price span.discount-coupon span`).textContent = discountedPrice;
        }
        
        document.querySelector('.summary .line.discount').classList.remove('hide');
        document.querySelectorAll(`[data-product="${productID}"] .discount-coupon`).forEach(element => {
          element.classList.remove('hide');
        });
      } else {
        document.querySelector('.summary .line.discount').classList.add('hide');
        document.querySelector(`[data-product="${productID}"] .product-price .price`).textContent = totalPrice;
        document.querySelectorAll(`[data-product="${productID}"] .discount-coupon`).forEach(element => {
          element.classList.add('hide');
        });
      }

    }
    
    document.querySelector(".summary .line.discount span.discount").textContent = formatMoney(totalDiscount, format);
  }
}

function checkProductInCartAndPrompt(form) {
  const productId = form.dataset.productId;
  const formData = new FormData(form);

  fetch('/cart.json')
    .then(res => res.json())
    .then(cart => {
      const sameProductItems = cart.items.filter(item => item.product_id == productId);

      if (sameProductItems.length > 0) {
        console.log("Já tem esse produto no carrinho.")
      } else {
        console.log("Não tem esse produto no carrinho.")
      }
    });
}

function updateCart(data, key, element, action) {  
  const totalDiscount = data.total_discount;
  const discounts = data.items.discounts;
  
  if (data.items.length === 0) {
    document.querySelector('.cart-content').remove();
    document.querySelector('.counter-element').remove();
    document.querySelector('.upsell').remove();
    document.querySelector('.empty-cart').classList.remove('hide');
    document.querySelector(".header-middle span.cart-count").textContent = 0;
  } 
  
  else {
    const item_count = data.item_count;
    const totalPrice = formatMoney(data.total_price, format);
    const handle = document.querySelector(`.line[data-key="${key}"]`).getAttribute("data-handle");
    var quantity = Number(document.querySelector(`.line[data-key="${key}"] .quantity-button input`).value);

    axios.get("/products/"+handle+".js", {})
    .then((res) => {
      var line = document.querySelector(`.line[data-key="${key}"] .product-price .old p`);

      // console.log(res.data);

      // if(quantity == 1) {
      //   document.querySelector(`.line[data-key="${key}"] .product-price .price`).textContent = formatMoney(res.data.price, format);
      // }
      
      if (res.data.compare_at_price > 0) {
        if (action == "minus") {
           if (quantity > 1) {
             var itemCompareAtPrice = formatMoney((res.data.compare_at_price * (quantity + 1)) - res.data.compare_at_price, format);
           } else {
             var itemCompareAtPrice = formatMoney(res.data.compare_at_price, format);
           }
        } else {
           var itemCompareAtPrice = formatMoney(res.data.compare_at_price * quantity, format);
        }

        if (line) {
          line.textContent = itemCompareAtPrice;
        } 
      }
    });

    if (action == "remove") {
      removeFadeOut(element, 100);
    }
    
    document.querySelector(".header-middle span.cart-count").textContent = item_count;
    document.querySelectorAll(".item-counter").forEach(span => {
      span.textContent = item_count;
    });
    
    document.querySelector(".line.total .total-price p").textContent = totalPrice;
  }
}

function updateSummary(data, handle, price, action) {
  var totalPrice = formatMoney(data.total_price, format);
  var total_discount = data.total_discount;

  var lineElement = document.querySelector(`.line[data-handle="${handle}"]`);
  var oldPriceElement = lineElement?.querySelector(".product-price .old");
  var dataOldPrice = oldPriceElement ? oldPriceElement.getAttribute("data-old-price") : null;

  var quantityField = lineElement?.querySelector(".quantity-field");
  var currentQuantity = quantityField ? quantityField.getAttribute("value") : 1;

  var quantity = 0;
  if (action !== "remove") {
    var item = data.items.find(item => item.handle === handle);
    quantity = item ? item.quantity : 0;
  }

  if (data.item_count > 0) {
    document.querySelector(".summary .line span.price").textContent = totalPrice;
    document.querySelector(".line.total .total-price p").textContent = totalPrice;
    document.querySelector(".header-middle span.cart-count").textContent = data.item_count;
  }

  document.querySelectorAll(".item-counter").forEach(span => {
    span.textContent = data.item_count;
  });

  axios.get(`/products/${handle}.js`)
    .then((res) => {
      if (document.querySelector('.summary')) {
        var summaryOldPriceElement = document.querySelector('.summary .line span.old-price');
        var summaryCompareAtPrice = summaryOldPriceElement ? unFormatMoney(summaryOldPriceElement.textContent) : "empty";

        let compare_at_price;
        if (action === "remove" && quantity === 0) {
          compare_at_price = summaryCompareAtPrice - (res.data.compare_at_price * currentQuantity);
        } else if (action === "remove") {
          compare_at_price = summaryCompareAtPrice - (res.data.compare_at_price * quantity);
        } else if (action === "minus") {
          compare_at_price = summaryCompareAtPrice - res.data.compare_at_price;
        } else {
          compare_at_price = summaryCompareAtPrice + res.data.compare_at_price;
        }

        if (compare_at_price > price) {
          summaryOldPriceElement.textContent = formatMoney(compare_at_price, format);
          var updateSaved = (compare_at_price - price) + shipping_cost + total_discount;
          document.querySelector(".summary .line .saved").textContent = formatMoney(updateSaved, format);
        } else {
          if (summaryCompareAtPrice === "empty") {
            let cartItemsCompareAtPrice = 0;
            document.querySelectorAll(".cart-items .line .product-price .old p").forEach(p => {
              cartItemsCompareAtPrice += unFormatMoney(p.textContent);
            });

            if (cartItemsCompareAtPrice > price) {
              summaryOldPriceElement.textContent = formatMoney(cartItemsCompareAtPrice, format);
              var updateSaved = (cartItemsCompareAtPrice - price) + shipping_cost + total_discount;
            } else {
              var updateSaved = shipping_cost + total_discount;
            }

            document.querySelector(".summary .line .saved").textContent = formatMoney(updateSaved, format);
          } else {
            summaryOldPriceElement.textContent = "";
            var updateSaved = shipping_cost + total_discount;
            document.querySelector(".summary .line .saved").textContent = formatMoney(updateSaved, format);
          }
        }
      }
    });

  updateInstallment('.summary .line span.installment', price.toString(), format);
}

function postMessageToPlayer(player, command){
  if (player == null || command == null) return;
  player.contentWindow.postMessage(JSON.stringify(command), "*");
}

function playPauseVideo(slick, control) {
  var currentSlide, slideType, startTime, player, video;

  currentSlide = slick.find(".slick-current");
  slideType = currentSlide.attr("class").split(" ")[3];
  player = currentSlide.find("iframe").get(0);
  startTime = currentSlide.data("video-start");
  
  if (slideType === "vimeo") {
    switch (control) {
      case "play":
        if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
          currentSlide.addClass('started');
          postMessageToPlayer(player, {
            "method": "setCurrentTime",
            "value" : startTime
          });
        }
        postMessageToPlayer(player, {
          "method": "play",
          "value" : 1
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "method": "pause",
          "value": 1
        });
        break;
    }
  } else if (slideType === "youtube") {
    switch (control) {
      case "play":
        // postMessageToPlayer(player, {
        //   "event": "command",
        //   "func": "mute"
        // });
        postMessageToPlayer(player, {
          "event": "command",
          "func": "playVideo"
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "pauseVideo"
        });
        break;
    }
  } else if (slideType === "webvideo") {
    video = currentSlide.children("video").get(0);
    if (video != null) {
      if (control === "play"){
        video.play();
      } else {
        video.pause();
      }
    }
  }
}

function validAddressForm(modal) {
  var modal = modal;
  var form = modal.querySelector("form")
  var isEditModal = modal.querySelector("input[data-name]")
  
  var buttonSendForm = modal.querySelector('button[type="submit"]')
  var buttonCancel = modal.querySelector('button[type="close"]')
  
  var fieldName = modal.querySelector(".nome")
  var fieldZip = modal.querySelector(".cep")
  var fieldAddress = modal.querySelector(".endereco")
  var fieldNumber = modal.querySelector(".numero")
  var fieldComplement = modal.querySelector(".complemento")
  var fieldDistrict = modal.querySelector(".bairro")
  var fieldCity = modal.querySelector(".cidade")
  var fieldState = modal.querySelector(".uf")
  var fieldFullAddress = modal.querySelector(".endereco_completo")
  var fieldDefaultAddress = modal.querySelector("input[type='checkbox']")
  
  fieldName.addEventListener("focusout", function () {
    if (fieldName.value.length < 6) {
        validAlert("alert-name")
        fieldName.parentNode.after(getAlertField("Please enter your first and last name", "error", "alert-name"));
        fieldName.classList.add("error")
        fieldName.parentNode.classList.remove("approved")
        fieldName.focus();
    } else {
      fieldName.classList.remove("error")
      fieldName.parentNode.classList.add("approved")
      
      validAlert("alert-name")
    }
  })
  
  fieldName.addEventListener("keyup", function () {
    if (fieldName.value.length < 6) {
        validAlert("alert-name")
        fieldName.parentNode.after(getAlertField("Please enter your first and last name", "error", "alert-name"));
        fieldName.classList.add("error")
        fieldName.parentNode.classList.remove("approved")
        fieldName.focus();
    } else {
      fieldName.classList.remove("error")
      fieldName.parentNode.classList.add("approved")
      
      validAlert("alert-name")
    }
  })
  
  [fieldAddress, fieldNumber, fieldComplement, fieldDistrict, fieldCity, fieldState].forEach(function (field) {
    field.readOnly = false;
    field.disabled = false;
    field.addEventListener('input', function () {
      fieldFullAddress.value = [fieldAddress.value, fieldNumber.value, fieldComplement.value, fieldDistrict.value, fieldCity.value, fieldState.value].join(';');
    });
  });
  fieldZip.addEventListener('input', function () {
    this.value = this.value.toUpperCase().replace(/[^A-Z0-9 ]/g, '').slice(0, 8);
    validAlert('alert-zip');
    var valid = /^(GIR ?0AA|[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2})$/.test(this.value.trim());
    this.classList.toggle('error', !valid);
    buttonSendForm.disabled = !valid;
  });

  fieldZip.addEventListener("focusout", function () {
    if (fieldZip.classList.contains("error")) {
      fieldZip.focus();
    }
  })
  
  fieldNumber.addEventListener("keyup", function () {   
    var number = fieldNumber.value;
    var address = fieldFullAddress.value;
    let array = address.split(';');
  
    array.splice(1, 1, number);
    var address = array.join(';');
  
    fieldFullAddress.value = address;
  
    if (fieldNumber.value.length > 0) {
      fieldNumber.parentNode.classList.add("approved")
    } else {
      fieldNumber.parentNode.classList.remove("approved")
    }
  });
  
  fieldComplement.addEventListener("keyup", function () { 
    var number = fieldComplement.value;
    var address = fieldFullAddress.value;
    let array = address.split(';');
  
    array.splice(2, 1, number);
  
    var address = array.join(';');
    fieldFullAddress.value = address;
  
    if (fieldComplement.value.length > 0) {
      fieldComplement.parentNode.classList.add("approved")
    } else {
      fieldComplement.parentNode.classList.remove("approved")
    }
  });
  
  buttonSendForm.addEventListener("click", function () {
    if(isEditModal) {
      var action = form.getAttribute("action")
      form.removeAttribute("action")
      form.setAttribute("action", action+"#edited")
      
    } else {
      var action = form.getAttribute("action")
      form.removeAttribute("action")
      form.setAttribute("action", action+"#new")
    }
    
    form.submit();
  });
  
  buttonCancel.addEventListener("click", function () {
    if (isEditModal) {
      fieldName.value = modal.querySelector("input[data-name]").dataset.name;
      fieldZip.value = modal.querySelector("input[data-zip]").dataset.zip;
      fieldAddress.value = modal.querySelector("input[data-address]").dataset.address;
      fieldNumber.value = modal.querySelector("input[data-number]").dataset.number;
      fieldComplement.value = modal.querySelector("input[data-complement]").dataset.complement;
      fieldDistrict.value = modal.querySelector("input[data-district]").dataset.district;
      fieldCity.value = modal.querySelector("input[data-city]").dataset.city;
      fieldState.value = modal.querySelector("input[data-state]").dataset.state;
      fieldFullAddress.value = modal.querySelector("input[data-address-total]").dataset.addressTotal;
    } else {
      modal.querySelectorAll("input:not([type=hidden])").forEach(input => {
        input.value = "";
      })
    }

    if (fieldDefaultAddress) {
      fieldDefaultAddress.checked = false;
    }
  
    fieldNumber.disabled = fieldComplement.disabled = false;
    buttonSendForm.disabled = false;
  
    validAlert("alert-zip")
  
    document.querySelectorAll(".fields").forEach(div => {
      div.classList.remove("approved")
    });
    
    document.querySelectorAll("input").forEach(input => {
      input.classList.remove("error")
    });
  });
}

function getAlert(message, type, id) {
  const div = document.createElement('div')
  div.setAttribute('class', 'alert alert-'+type)

  if (id) {
    div.setAttribute('id', id)
  }

  if (type == "info") {
    var icon = '<i class="fas fa-info-circle"></i>'
  }
  else if (type == "error") {
    var icon = '<i class="fa-solid fa-xmark"></i>'
  }
    
  else if (type == "success") {
    var icon = '<i class="fa-solid fa-check"></i>'
  }
  
  div.innerHTML = icon+" "+message
  
  return div
}

function getAlertField(message, type, id) {
  const div = document.createElement('div')
  div.setAttribute('class', 'alert-field alert-'+type)

  if (id) {
    div.setAttribute('id', id)
  }

  if (type == "info") {
    var icon = '<i class="fas fa-info-circle"></i>'
  }
  else if (type == "error") {
    var icon = '<i class="fa-solid fa-xmark"></i>'
  }
  
  div.innerHTML = icon+" "+message
  
  return div
}

function validAlert(id) {
  const alert = document.querySelector("#"+id)
  
  if (alert) {
    alert.remove();
  }
}

function filterById(jsonObject, id) {return jsonObject.filter(function(jsonObject) {return (jsonObject['id'] == id);})[0];}

function formatText (text) {       
  text = text.toLowerCase();                                                         
  text = text.replace(new RegExp('[ÁÀÂÃ]','gi'), 'a');
  text = text.replace(new RegExp('[ÉÈÊ]','gi'), 'e');
  text = text.replace(new RegExp('[ÍÌÎ]','gi'), 'i');
  text = text.replace(new RegExp('[ÓÒÔÕ]','gi'), 'o');
  text = text.replace(new RegExp('[ÚÙÛ]','gi'), 'u');
  text = text.replace(new RegExp('[Ç]','gi'), 'c');
  return text;
}

function insertBeforeFirst(strToSearch, strToFind, strToInsert) {
    var n = strToSearch.indexOf(strToFind);
    if (n < 0) return strToSearch;
    return strToSearch.substring(0,n) + strToInsert + strToSearch.substring(n);    
}

function getCookie(cookieName) {
  var name = cookieName + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(cookieName, cookieValue, days) {
  var expires = "";

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }

  document.cookie = cookieName + "=" + encodeURIComponent(cookieValue) + expires + "; path=/";
}

function deleteCookie(cookieName) {
  document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

function jsonTransform(columns) {
    var jsonData = {};
    columns.forEach(function(column) 
    {
        var columnName = column.metadata.colName;
        jsonData[columnName] = column.value;
    });
    viewData.employees.push(jsonData);
}

function getOffset(el) {
  const rect = el.getBoundingClientRect();
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY
  };
}

function getParameterByName(name) {
  const url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function openModal(modal) {
    modal.classList.remove("close");
    modal.classList.add("open");
    document.body.classList.add("block-overflow");

    const content = modal.querySelector(".window-modal-content");
    if (content) {
        content.classList.add("overflow-hidden");
        setTimeout(() => {
            content.classList.remove("overflow-hidden");
        }, 1000);
    }

    if (!modal.dataset.listenerBound) {
        modal.dataset.listenerBound = "true";

        modal.addEventListener("click", function (e) {
            if (e.target === modal) {
              closeModal(modal);
            }

            if (e.target.id === "close") {
              closeModal(modal);
            }
        });
    }
}

function closeModal(modal) {
  modal.classList.remove("open");
  modal.classList.add("close");
  document.body.classList.remove("block-overflow");
}


function formatReviewNumbers() {
  var elements = document.querySelectorAll(
    '.alr-wh-review-star-rating-number, .alr-wh-rating-total-review'
  );

  if (!elements.length) return;

  elements.forEach(function (el) {
    if (!el) return;

    var text = (el.textContent || '').trim();
    if (!text) return;

    var updated = text.replace(/\b\d{1,3}(?:,\d{3})+\b/g, function (match) {
      return match.replace(/,/g, '.');
    });

    if (updated !== text) {
      el.textContent = updated;
    }
  });
}

window.FavoritesSystem = (function () {
    var storageKey = 'theme_favorites_v1';

    function sanitizeHandle(handle) {
        return String(handle || '')
            .toLowerCase()
            .trim()
            .replace('/products/', '')
            .split('?')[0]
            .replace(/[^a-z0-9-_]/g, '');
    }

    function getItems() {
        try {
            var items = JSON.parse(localStorage.getItem(storageKey)) || [];
            return items.map(sanitizeHandle).filter(Boolean);
        } catch (e) {
            return [];
        }
    }

    function saveItems(items) {
        items = [...new Set(items.map(sanitizeHandle).filter(Boolean))];

        localStorage.setItem(storageKey, JSON.stringify(items));

        document.cookie = storageKey + '=' + encodeURIComponent(JSON.stringify(items)) + '; path=/; max-age=31536000; SameSite=Lax';
    }

    function has(handle) {
        return getItems().indexOf(sanitizeHandle(handle)) > -1;
    }

    function add(handle) {
        var items = getItems();
        handle = sanitizeHandle(handle);

        if (!handle || items.indexOf(handle) > -1) return items;

        items.push(handle);
        saveItems(items);

        return items;
    }

    function remove(handle) {
        handle = sanitizeHandle(handle);

        var items = getItems().filter(function (item) {
            return item !== handle;
        });

        saveItems(items);

        return items;
    }

    function toggle(handle) {
        return has(handle) ? remove(handle) : add(handle);
    }

    return {
        getItems: getItems,
        saveItems: saveItems,
        has: has,
        add: add,
        remove: remove,
        toggle: toggle,
        sanitizeHandle: sanitizeHandle
    };
})();